<a [class.selected]="isSelected" class="ticket-link" [routerLink]="['/home/ticket', ticket.ticketId]">

<!-- <div class="ticket-title" sa-ellipsis-text one-time="false" full-text="ticket.title || ('ticketCard_Subject_Placeholder' | xsI18n)"></div> -->
<div #ticketTitle class="ticket-title" [matTooltip]="ticket?.title" matTooltipPosition="above"
[matTooltipDisabled]="ticketTitle | xsMatToolTipDisable" matTooltipClass="xsight-mat-tooltip" >
    {{ ticket.title || ('ticketCard_Subject_Placeholder' | xsI18n) }}
</div>

<div class="ticket-details-wrapper">
  <div class="ticket-id">{{ ticket.shortGroupName }}-{{ ticket.ticketId }}</div>
    <div class="ticket-group-name-container" *ngIf="groupName">
        <span class="list-separator"></span>
        <span #tooltipElement class="ticket-group-name subtext" [matTooltip]="groupName"
        matTooltipPosition="above" matTooltipClass="xsight-mat-tooltip"
        [matTooltipDisabled]="tooltipElement | xsMatToolTipDisable">
          {{ groupName | xsI18n }}
        </span>
        <span class="list-separator"></span>
    </div>
    <div class="ticket-status" ng-hide="false">
        <div class="hd-icon {{ticketStatus.glyphicon}}"></div>
        <span class="status-caption">{{ticketStatus.caption | xsI18n}}</span>
    </div>
</div>
</a>
